/* Template: Component - Element link
========================================================================== */
template.component.elementLink = function() {

  $('.element-link').click(function() {
      window.location = $(this).find("a").attr("href");
      return false;
  });
};
